export const QUARTZ_DISCOVER_IDENTITY = 'qz.com/discover'
export const QUARTZ_DISCOVER_URL = `https://${QUARTZ_DISCOVER_IDENTITY}`
export const QUARTZ_REFERRER_POLICY = 'origin-when-cross-origin'
